import {
  personChangesUrl,
  rolechangesUrl,
  packagechangesUrl,
  sitechangesUrl,
  addPersonUrl,
  siteDetailUrl,
  ctsuUpdatePersonAttrDetailsUrl,
} from "stores/redux/actions/constants";

import {
  SAVE_SELECTED_CRED_REQ_STATUS,
  FETCH_CREDENTIALING_REQUEST_DETAILS,
  SAVE_SELECTED_CRED_ROW_DATA,
} from "../types";

export function getUrl(data) {
  let result;
  const reqType = data?.reqType
    ? data.reqType.toLowerCase().split(" ").join("_")
    : "";
  switch (reqType) {
    case "add_person":
      result = addPersonUrl(data.id);
      break;
    case "withdraw_person":
      result = personChangesUrl(data.id);
      break;
    case "add_role":
    case "withdraw_role":
      result = rolechangesUrl(data.id);
      break;

    case "add_site":
    case "withdraw_site":
      result = sitechangesUrl(data.id);
      break;
    case "claim_package":
      result = packagechangesUrl(data.id);
      break;
    case "update_person_attributes":
      result = addPersonUrl(data.id);
      break;
    case "update_person_documents":
      result = addPersonUrl(data.id);
      break;
    case "ctsu_update_institution_attribute":
      result = siteDetailUrl(data.id);
      break;
    case "ctsu_update_person_attribute":
      result = ctsuUpdatePersonAttrDetailsUrl(data.id);
      break;
    default:
      break;
  }
  return result;
}

export const saveSelectedCredReqStatus =
  (data, callback, nextRoute) => async (dispatch) => {
    const response = dispatch({
      type: SAVE_SELECTED_CRED_REQ_STATUS,
      payload: Promise.resolve(data),
    });
    response.then(() => {
      callback(nextRoute);
    });
  };
export const resetSelectedCredRow = () => async (dispatch) => {
  const response = dispatch({
    type: SAVE_SELECTED_CRED_ROW_DATA,
    payload: Promise.resolve({}),
  });
  response.then(() => {
    dispatch({
      type: FETCH_CREDENTIALING_REQUEST_DETAILS,
      payload: Promise.resolve({}),
    });
  });
};
export const saveSelectedCredRow = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_SELECTED_CRED_ROW_DATA,
    payload: Promise.resolve(data),
  });
};
